import React from 'react';
import { DispatcherCapabilityType } from '../../../models/enums/dispatcherCapabilityType';
import { permissionService } from '../../../services/permissionService';

interface Props {
  capability: DispatcherCapabilityType;
  children: React.ReactNode;
}

export const ShowForDispatcherCapability: React.FC<Props> = ({ capability, children }) =>
  permissionService.hasDispatcherCapability(capability) ? <>{children}</> : null;
